import { render, staticRenderFns } from "./loading-full.vue?vue&type=template&id=30474940&scoped=true"
import script from "./loading-full.vue?vue&type=script&lang=js"
export * from "./loading-full.vue?vue&type=script&lang=js"
import style0 from "./loading-full.vue?vue&type=style&index=0&id=30474940&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30474940",
  null
  
)

export default component.exports